var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"step-title"},[_c('div',{staticClass:"step-title-number"},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"step-title-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }